import { render, staticRenderFns } from "./TopicFormationDashboard.vue?vue&type=template&id=c7d815f2&"
import script from "./TopicFormationDashboard.vue?vue&type=script&lang=js&"
export * from "./TopicFormationDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports